function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useState } from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { getIcon } from "../AlertBase/AlertBase";
import { useStyle } from "./AppAlert.styles";
import XIcon from "../../Icon/X";
import { AlertDismissButton } from "../AlertDismissButton/AlertDismissButton";
import Button from "../../Button/Button";
export var AppAlert = function(param) {
    var content = param.content, onDismiss = param.onDismiss, _dismissible = param.dismissible, dismissible = _dismissible === void 0 ? true : _dismissible, dismissButtonAriaLabel = param.dismissButtonAriaLabel, action = param.action, _appearance = param.appearance, appearance = _appearance === void 0 ? 'info' : _appearance, accessibilityLabel = param.accessibilityLabel, id = param.id, testID = param.testID, _isRtl = param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl;
    var ref = useStyle(appearance, dismissible, !!action, isRtl), container = ref.container, iconContentStyle = ref.iconContent, icon = ref.icon, contentActionStyle = ref.contentAction, contentStyle = ref.content, actionStyle = ref.action, dismissStyle = ref.dismiss, dismissButtonStyle = ref.dismissButton;
    var ref1 = _slicedToArray(useState(true), 2), isVisible = ref1[0], setIsVisible = ref1[1];
    return isVisible ? _jsxs("div", _objectSpread({
        role: appearance === 'danger' ? 'alert' : 'status',
        "aria-live": appearance === 'danger' ? 'assertive' : 'polite',
        "aria-label": accessibilityLabel,
        css: container
    }, injectTestId(testID), {
        children: [
            _jsxs("div", {
                css: contentActionStyle,
                children: [
                    _jsxs("div", {
                        css: iconContentStyle,
                        children: [
                            _jsx("div", {
                                css: icon,
                                children: getIcon(appearance)
                            }),
                            _jsx("div", {
                                css: contentStyle,
                                children: content
                            })
                        ]
                    }),
                    action && _jsx("div", {
                        css: actionStyle,
                        children: action
                    })
                ]
            }),
            dismissible && _jsx("div", {
                css: dismissStyle,
                children: appearance === 'warning' ? _jsx(AlertDismissButton, {
                    iconAlign: "end",
                    isRtl: isRtl,
                    appearance: "warning",
                    style: dismissButtonStyle,
                    icon: XIcon,
                    accessible: true,
                    accessibilityLabel: dismissButtonAriaLabel,
                    onClick: function() {
                        setIsVisible(false);
                        return onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(id);
                    }
                }) : _jsx(Button, {
                    iconAlign: "end",
                    isRtl: isRtl,
                    appearance: "ghost",
                    variant: "neutral-white",
                    isPill: true,
                    size: "s",
                    icon: XIcon,
                    accessible: true,
                    accessibilityLabel: "Dismiss",
                    onClick: function() {
                        setIsVisible(false);
                        return onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(id);
                    }
                })
            })
        ]
    }), id) : null;
};
